import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagModificarPrecioVentaFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagModificarPrecioVenta'>
      {({ field }) => <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagModificarPrecioVenta' label='Modificar Precios Venta' />}
    </Field>
  )
}

export default React.memo(FlagModificarPrecioVentaFormGroup)
